/*eslint-disable*/
import api from '../'

class connectThePuzzles {
    static getItemsByRequest (params) {
        return api.axios.get('/connectThePuzzles/items', { params }).then(response => response.data.items);
    }
}

export default connectThePuzzles;
